import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const AgregarPerfilAlarmaService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Alarma/AgregarAlarmaPerfil",
            values, customConfig
        );
        return resultado
    } catch (error) {
        console.log(error);
    }
}
export { AgregarPerfilAlarmaService };